import { useQuery } from '@tanstack/react-query';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { DateService, getRule } from 'Services';
import { getCustomUserName, RQ_GLOBAL_RULES } from 'Utils';

type Props = {
    ruleId: string;
    users?: UsersHashmap;
};
const useGetRule = ({ ruleId, users }: Props) => {
    const { templateRepositoryId } = useTemplateStore.getState().template;
    return useQuery([RQ_GLOBAL_RULES, templateRepositoryId, ruleId], () => getRule(ruleId, templateRepositoryId!), {
        enabled: !!(templateRepositoryId && templateRepositoryId > 0),
        select: (rule) => {
            return {
                ...rule,
                _formatted: {
                    createdAt: DateService.getDateTime(rule.createdAt) ?? rule.createdAt,
                    createdBy: getCustomUserName(rule.createdBy, users)
                }
            };
        }
    });
};

export default useGetRule;
